import { stateIds, isAdjacentTeeth } from "./index";

/**
 * Break bridges to separate parts based on tooth numbers and pillar types
 */
export const breakBridgesToParts = (selection) => {
    const parts = [];
    let subSelection = [];
    let prevId = null;
    let prevPillar = 0;
    let pillarStateId = stateIds.missing;

    selection.forEach((tId) => {
        pillarStateId = getPillarStateId(parseInt(tId));
        if (prevId !== null) {
            if (!isAdjacentTeeth(prevId, tId) || (prevPillar !== 0 && pillarStateId !== stateIds.missing && pillarStateId !== prevPillar)) {
                parts.push(JSON.parse(JSON.stringify(subSelection)));
                subSelection = [];
                prevPillar = 0;
            }
        }
        subSelection.push(tId);
        prevId = tId;
        if (pillarStateId !== stateIds.missing) prevPillar = pillarStateId;
    });

    if (subSelection.length > 0) parts.push(JSON.parse(JSON.stringify(subSelection)));

    return parts;
}

/**
 *
 * @param { number } toothId
 * @returns { number } stateId
 */
const getPillarStateId = (toothId) => {

    // Valid pillar stateIds for a bridge
    const validPillars = [
        stateIds.implant,
        stateIds.implantOnePhase,
        stateIds.worn,
        stateIds.filed
    ];

    let stateId = stateIds.missing;

    app.$store.state.simplePlan.status.forEach((item) => {
        if (toothId == item.tooth_id) stateId = item.state_pid;
    });

    app.$store.state.simplePlan.steps.forEach((step) => {
        if (step.tooth_id.includes(toothId) && validPillars.includes(step.state_pid)) stateId = step.state_pid;
    });

    if (stateId === stateIds.worn) stateId = stateIds.filed;

    return stateId;
}
